"use client";
import React, { useEffect, useRef } from "react";

import { useTranslation } from "react-i18next";

function About() {
  const sectionRef = useRef(null);
  const { t } = useTranslation("translation");
  useEffect(() => {
    if (window.location.hash === "#contact") {
      sectionRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);
  return (
    <div ref={sectionRef} id="about">
      <h1 className="text-2xl font-bold mb-2 text-[var(--color-main)]">
        {t("about.about")}
      </h1>
      <p>
        {t("about.text")}.{" "}
        <span className="font-bold text-[var(--color-main)]">
          {t("about.coderHub")}
        </span>
      </p>
    </div>
  );
}

export default About;
